import api from '../utils/api';

export default {
    namespaced: true,
    state: {
        providers: [],
        schemas: [],
        endpoints: [],
        mappings: [],
        provider: {},
        params: {
            profileProvider: undefined,
            schema: undefined,
            endpoint: undefined,
            mappings: undefined,
        },
    },
    getters: {
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST(state, data) {
            state.providers = data;
            state.schemas = [];
            state.endpoints = [];
            state.mappings = [];
            state.provider = {};
        },
        SET_PARAMS(state, data) {
            state.params = data || {
                profileProvider: undefined,
                schema: undefined,
                endpoint: undefined,
                mapping: undefined,
            };
        },
        SET_PROVIDER(state, data) {
            state.provider = data || [];
        },
        SET_SCHEMAS(state, schemas) {
            state.schemas = schemas || [];
        },
        SET_ENDPOINTS(state, endpoints) {
            state.endpoints = endpoints || [];
        },
        SET_MAPPINGS(state, mappings) {
            state.mappings = mappings || [];
        },
    },
    /* eslint-disable no-unused-vars */
    actions: {
        LIST_ALL(context) {
            return api.get('/profileProviders')
                .then(response => context.commit('LIST', response.data))
                .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
        LOAD(context, value) {
            return Promise.all([
                api.get(`/profileProviders/${value.profileProvider}`)
                    .then(providerData => context.commit('SET_PROVIDER', providerData.data)),
                api.get(`/profileProviders/${value.profileProvider}/schemas`)
                    .then(schemasList => context.commit('SET_SCHEMAS', schemasList.data)),
                (value.schema
                    ? api.get(`/profileProviders/${value.profileProvider}/schemas/${value.schema}/endpoints`)
                    : Promise.resolve([]))
                    .then(endpointsList => context.commit('SET_ENDPOINTS', endpointsList.data)),
                (value.endpoint
                    ? api.get(`/profileProviders/${value.profileProvider}/schemas/${value.schema}/endpoints/${value.endpoint}/mappings`)
                    : Promise.resolve([]))
                    .then(mappingsList => context.commit('SET_MAPPINGS', mappingsList.data)),
            ])
            .then(() => context.commit('SET_PARAMS', value))
            .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/profileProviders.js